export default __webpack_public_path__ + "static/media/pho_02q.22e44c2f.jpg";